<template>
    <div class="product">
        <component :is="components[product.class]" :cartItem="cartItem" :product="product"></component>
        <div class="right">
            <div>
                <!--input type="number" v-model="quantity" @change="k => changeQuantity(k.target.value)" style="width: 32px">
                <br -->
                <a @click="deleteCart(cartItem.id)">Rimuovi</a>
            </div>
            <div>
                <b>{{utils.euro(this.cartItem.total)}}</b>
            </div>
        </div>
    </div>
</template>
<script>

import SimpleProduct from './SimpleProduct'
import utils from '@/utils.js'
import ComposableProduct from './ComposableProduct'
export default {
    props: ['product','cartItem'],
    data(){
        return {
            quantity: this.cartItem.quantity,
            components: {
                'simple': SimpleProduct,
                'composable': ComposableProduct
            },
            utils
        }
    },
    methods:{
        deleteCart(c){
            console.log(c);
            this.$store.dispatch('deleteCart',c);
        },
        changeQuantity(q){
            this.$store.dispatch('changeCartQuantity',{idItem: this.cartItem.id,quantity: q});
        }
    }
}
</script>

<style lang="scss" scoped>

    .product {
        display: grid;
        width: 100%;
        grid-template-columns: 3fr 1fr;
        align-items: center;
        padding: .5em 0;
        border-bottom: 1px solid #DDD
    }

    .right {
        text-align: right;
    }

</style>